/**
 * ChildAware Website
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type DomainOrganisationDeletionStatus = 'PendingApproval' | 'Approved' | 'Processing' | 'Completed' | 'Declined' | 'Failed';

export const DomainOrganisationDeletionStatus = {
    PendingApproval: 'PendingApproval' as DomainOrganisationDeletionStatus,
    Approved: 'Approved' as DomainOrganisationDeletionStatus,
    Processing: 'Processing' as DomainOrganisationDeletionStatus,
    Completed: 'Completed' as DomainOrganisationDeletionStatus,
    Declined: 'Declined' as DomainOrganisationDeletionStatus,
    Failed: 'Failed' as DomainOrganisationDeletionStatus
};